import React from 'react';

const SvgHamburger = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M3 6h18v1H3V6zm0 5h18v1H3v-1zm0 5h18v1H3v-1z" fill="#000" />
  </svg>
);

export default SvgHamburger;
